import { MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";
import { Button, cn, Icons, Spinner } from "@win-reality/react-ui";
import { Link } from "react-router-dom";

import decorativeArcs from "@/assets/decorative-arcs.svg";

import { ComplexHealth } from "./components/ComplexHealth";

type ComplexHealth = "healthy" | "needs_attention";

type ComplexesItemProps = {
  name: string;
  fieldCount: number;
  activeEvents: number;
  scheduledEvents: number | undefined;
  imageUrl?: string;
  fields: MachinePublicHydrated[];
};

function ComplexesItem({
  name,
  fieldCount,
  activeEvents,
  scheduledEvents,
  imageUrl,
  fields,
}: ComplexesItemProps) {
  return (
    <div
      className={cn(
        "relative flex h-67.5 overflow-hidden rounded-2xl bg-[#24252C] bg-cover bg-center",
      )}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      {!imageUrl && (
        <img
          src={decorativeArcs}
          alt=""
          className="pointer-events-none absolute -left-15 top-1/2 h-full -translate-y-1/2 opacity-30"
        />
      )}

      {imageUrl && (
        <div className="w-full h-full absolute inset-0 bg-linear-to-b from-black/10 to-black"></div>
      )}

      <div
        className={cn(
          "relative z-10 flex w-full flex-col justify-between p-6",

          imageUrl && "text-shadow-sm",
        )}
      >
        <div>
          <p className="text-xs font-medium text-white mt-0.5">
            {fieldCount} {fieldCount === 1 ? "Field" : "Fields"}
          </p>
          <h3 className="mt-2 text-base text-white">{name}</h3>
        </div>

        <div className="flex max-w-xs flex-col gap-0 min-w-42">
          <div className="flex items-center justify-between border-b border-white/20 py-2">
            <span className="text-xs pr-2 uppercase tracking-wider text-white">
              Active Events
            </span>
            <span className="text-sm text-white">{activeEvents}</span>
          </div>
          <div className="flex items-center justify-between border-b border-white/20 py-2">
            <span className="text-xs pr-2  uppercase tracking-wider text-white">
              Scheduled Events
            </span>
            <span className="text-sm text-white">
              {scheduledEvents === undefined ? (
                <Spinner className="h-3.5 w-3.5 align-middle" />
              ) : (
                scheduledEvents
              )}
            </span>
          </div>

          <div className="dark">
            <ComplexHealth complexName={name} fields={fields} />
          </div>
        </div>
      </div>

      <div className="relative z-10 flex items-end p-6">
        <Link to={`/manage-smartparks/complex/${name}`}>
          <Button
            variant="secondary-flat-dark"
            size="icon-mini"
            className="h-12 w-12 rounded-full bg-white hover:bg-white/90"
          >
            <Icons.ArrowRightMini className="h-5 w-5 text-black" />
          </Button>
        </Link>
      </div>
    </div>
  );
}

export { ComplexesItem };
export type { ComplexesItemProps, ComplexHealth };
